import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Cheques from "@/pages/Cheques";
import Receivables from "@/pages/Receivables";
import Expenses from "@/pages/Expenses";
import BankAccounts from "@/pages/BankAccounts";
import RecurringExpenses from "@/pages/RecurringExpenses";
import Cash from "@/pages/Cash";
import AdminUsers from "@/pages/AdminUsers";
import PermissionGate from "@/components/PermissionGate";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Dashboard />} />
              <Route path="/cekler" element={<PermissionGate section="cheques"><Cheques /></PermissionGate>} />
              <Route path="/alacaklar" element={<PermissionGate section="receivables"><Receivables /></PermissionGate>} />
              <Route path="/giderler" element={<PermissionGate section="expenses"><Expenses /></PermissionGate>} />
              <Route path="/tekrarlayanlar" element={<PermissionGate section="recurring"><RecurringExpenses /></PermissionGate>} />
              <Route path="/kasa" element={<PermissionGate section="cash"><Cash branch="main" title="Merkez Kasa" section="cash" testidPrefix="cash" /></PermissionGate>} />
              <Route path="/kasa-bagcilar" element={<PermissionGate section="cash_bagcilar"><Cash branch="bagcilar" title="Bağcılar Şube Kasa" section="cash_bagcilar" testidPrefix="cash-bagcilar" /></PermissionGate>} />
              <Route path="/hesaplar" element={<PermissionGate section="bank_accounts"><BankAccounts /></PermissionGate>} />
              <Route path="/admin" element={<AdminUsers />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
